import { useEffect, useState } from "react";
import { Check, Minus } from "lucide-react";
import api from "@/lib/api";

export function PlanComparison({ plans, currentPlan }) {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/business/features").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  if (!info || !plans.length) return null;
  const keys = Object.keys(info.labels);
  return (
    <div className="space-y-3" data-testid="plan-comparison">
      <div>
        <h2 className="font-serif text-2xl text-foreground">Compare plans</h2>
        <p className="text-sm text-muted-foreground">Every module each plan unlocks.</p>
      </div>
      <div className="overflow-x-auto border border-border rounded-md bg-card">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left font-medium text-muted-foreground px-4 py-3 text-xs uppercase tracking-widest">Module</th>
              {plans.map((p) => (
                <th key={p.id} className={`px-4 py-3 text-center font-serif text-base ${p.id === currentPlan ? "bg-ink text-cream" : "text-foreground"}`} data-testid={`compare-col-${p.id}`}>
                  {p.name}{p.id === currentPlan && <span className="block text-[10px] font-sans uppercase tracking-widest text-gold">Your plan</span>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {keys.map((k) => (
              <tr key={k} data-testid={`compare-row-${k}`}>
                <td className="px-4 py-2.5 text-foreground">{info.labels[k]}</td>
                {plans.map((p) => {
                  const has = (info.included_in[k] || []).includes(p.id);
                  return (
                    <td key={p.id} className={`px-4 py-2.5 text-center ${p.id === currentPlan ? "bg-secondary/60" : ""}`} data-testid={`compare-${p.id}-${k}`} data-included={has ? "true" : "false"}>
                      {has ? <Check className="w-4 h-4 text-accent mx-auto" /> : <Minus className="w-4 h-4 text-muted-foreground/40 mx-auto" />}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
